import { GE_CHECKOUT_PATH } from "@/libs/global-e/checkout-marker";
import { getLocalePrefix } from "@/libs/i18n/getLocalePrefix";

/**
 * GE 체크아웃으로 full-nav 할 주소 — **지금 보고 있는 로케일을 붙인다**(끝슬래시 포함).
 *
 * GE 는 결제 화면 언어를 우리 페이지의 `<html lang>` 에서 읽는다(Kyuri, 2026-09-30 설정).
 * 종전엔 로케일 없이 `/international-checkout` 으로 보내서, 미들웨어가 **국가 쿠키의 기본 언어**로
 * 다시 보냈다(`middleware.ts` 의 redirect — "쿠키 국가의 default 언어"). 그래서 보조 언어를 고른
 * 고객(예: US + 스페인어, CH + 독일어)이 결제에서 국가 기본 언어로 바뀌었다.
 *
 * 국가는 바뀌지 않는다 — 지금 페이지와 **같은 로케일**로 가므로 `getResolvedCountryCode` 결과가
 * 같다(dev 실측: US + `/es/` → `GlobalE_Data.countryISO` = US, 통화 $ 유지).
 *
 * ⚠️ 영어(`en`)는 기본 로케일이라 접두어가 빈 문자열이다. 비영어 기본 국가(AT·MX 등)에서 영어를
 * 고른 경우는 이 함수로 고쳐지지 않는다 — 사이트 전체의 기존 한계(`docs/locale-middleware-policy.md`,
 * "`/en` 명시 입력 + 비영어권 쿠키 → 자국어 redirect").
 *
 * **끝슬래시를 붙인다** — 사이트가 `trailingSlash: true` 라 슬래시 없는 주소는 308 을 한 번 더 탄다.
 * `window.location.href` 는 `<Link>` 와 달리 정규화해 주지 않는다(dev 실측: `/es/international-checkout`
 * → 308 → `/es/international-checkout/`). ⚠️ 슬래시는 **여기(href)에만** 붙인다 — 경로 **판정**은
 * 슬래시 없는 `router.pathname` 을 `GE_CHECKOUT_PATH` 와 비교한다(`checkout-marker.ts`).
 */
export function geCheckoutHref(locale: string | undefined): string {
  return `${getLocalePrefix(locale)}${GE_CHECKOUT_PATH}/`;
}
